import { render, staticRenderFns } from "./CustomersAddressForm.vue?vue&type=template&id=30afbb22&scoped=true&"
import script from "./CustomersAddressForm.vue?vue&type=script&lang=js&"
export * from "./CustomersAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomersAddressForm.vue?vue&type=style&index=0&id=30afbb22&lang=scss&scoped=true&"
import style1 from "./CustomersAddressForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30afbb22",
  null
  
)

export default component.exports